const SVG_NS = 'http://www.w3.org/2000/svg';
const START = {x: -820, y: 210};
const TURN = {x: 760, y: -300};
const END = {x: 1250, y: -420};

const easeInOutSine = value => -(Math.cos(Math.PI * value) - 1) / 2;
const interpolate = (from, to, progress) => from + (to - from) * progress;

const makeMarkup = () => `
  <svg class="welcome-flight-motion" viewBox="-960 -540 1920 1080"
    aria-label="Ett flygplan flyger över hoppfältet" role="img">
    <line data-welcome-trail x1="${START.x}" y1="${START.y}"
      x2="${START.x}" y2="${START.y}" stroke="#fdf1e0"
      stroke-width="3" opacity=".3" />
    <g data-welcome-plane opacity="0">
      <rect x="-35" y="-5.5" width="70" height="11" rx="6" fill="#1c1428" />
      <path d="M-34 -3 L-18 -3 L-34 -24 Z" fill="#1c1428" />
      <rect x="-11" y="-11.5" width="30" height="5" rx="2" fill="#1c1428" />
      <rect x="-38" y="-4" width="16" height="4" rx="2" fill="#1c1428" />
    </g>
  </svg>
`;

export default function welcomeFlightLayer() {
  let container;
  let frame;
  let startedAt;

  const draw = timestamp => {
    if (!container) return;
    startedAt ??= timestamp;
    const elapsed = (timestamp - startedAt) / 1000;
    let x;
    let y;
    if (elapsed <= 7) {
      const progress = easeInOutSine(Math.min(1, elapsed / 7));
      x = interpolate(START.x, TURN.x, progress);
      y = interpolate(START.y, TURN.y, progress);
    } else {
      const progress = Math.min(1, (elapsed - 7) / 20);
      x = interpolate(TURN.x, END.x, progress);
      y = interpolate(TURN.y, END.y, progress);
    }
    const plane = container.querySelector('[data-welcome-plane]');
    const trail = container.querySelector('[data-welcome-trail]');
    plane?.setAttribute('transform', `translate(${x} ${y}) rotate(-18) scale(1.1)`);
    plane?.setAttribute('opacity', x > -800 ? '0.95' : '0');
    trail?.setAttribute('x2', String(x));
    trail?.setAttribute('y2', String(y));
    frame = requestAnimationFrame(draw);
  };

  return {
    mount(target) {
      container = target;
      target.innerHTML = makeMarkup();
      frame = requestAnimationFrame(draw);
    },
    unmount() {
      if (frame !== undefined) cancelAnimationFrame(frame);
      container?.replaceChildren();
      container = undefined;
      frame = undefined;
      startedAt = undefined;
    },
  };
}
